/**
 * Feature flags — выключают UI, не удаляя код.
 * Чтобы вернуть функцию: поставьте true.
 */

/** Смены + подсчёт / отображение онлайна (минуты, нормы, «на смене») */
export const SHIFTS_AND_ONLINE_ENABLED = false;
